import React from "react"
import api from "src/api"

export function useGetData() {
  const [dataItems, setDataItems] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [pagination, setPagination] = React.useState(null)

  React.useEffect(() => {
    getItems()
  }, [])

  const getItems = (page = 1, countOnPage = 20) => {
    setIsLoading(true)
    api
      .get(`additional-info?page=${page}&countOnPage=${countOnPage}`)
      .then(({ data }) => {
        setPagination({
          current: data.pagination.currentPage,
          pageSize: data.pagination.countOnPage,
          total: data.pagination.total,
        })
        setDataItems(getFormattedItems(data.items))
      })
      .finally(() => setIsLoading(false))
  }

  function handleTableChange(pagination) {
    getItems(pagination.current, pagination.pageSize)
  }

  function getFormattedItems(items) {
    return items.map((item) => ({
      ...item,
      key: item.id,
      titleRu: item.title?.find((el) => el.language === "ru")?.content ?? "",
    }))
  }

  return {
    dataItems,
    pagination,
    isLoading,
    handleTableChange,
    refetch: () => getItems(),
  }
}
